import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
  isActive(): boolean {
    return environment.maintenanceMode;
  }
}
